import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import { useTranslation } from 'react-i18next';

const UploadPrescription = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [file, setFile] = useState<File | null>(null);
  const [message, setMessage] = useState('');

  const handleUpload = async () => {
    if (!file) {
      alert('请先选择文件');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      await api.post(`/doctor/upload_prescription/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      setMessage('✅ 上传成功');
      setTimeout(() => navigate('/doctor/dashboard'), 1000);
    } catch (err) {
      setMessage('❌ 上传失败');
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">{t('doctor.upload_title')}</h2>

        <input
          type="file"
          accept="application/pdf"
          onChange={(e) => setFile(e.target.files?.[0] || null)}
          className="mb-4"
        />

        <button
          onClick={handleUpload}
          className="bg-coral text-white px-4 py-2 rounded-lg hover:opacity-90 transition"
        >
          {t('doctor.upload_confirm')}
        </button>

        {message && <p className="mt-4 text-center">{message}</p>}
      </div>
    </div>
  );
};

export default UploadPrescription;
